<template>
  <div id="app">
    <!-- Bannière pour le téléchargement FTP (affichée si l'API indique que c'est disponible) -->
    <div v-if="majDownloadAvailable && !updateDownloaded && !dismissMajBanner" class="update-bannerFTP"
      :class="{ 'no-header': $route.meta.noHeader }">
      <p class="mb-1 text-white">
        Une nouvelle version {{ majDownloadInfo.version }} est disponible.
      </p>
      <button class="close-btnBadge" @click="dismissMajBanner = true">Fermer</button>

    </div>

    <RouterView />
    <ShowToast />
    <DynamicDialog />

    <!-- template des alertes -->
    <ConfirmDialog group="headless">
      <template #container="{ message, acceptCallback, rejectCallback }">
        <div class="card card-body rounded surface-overlay" style="width: 18rem;">
          <h1 class="text-center mb-2">
            <span class="bg-warning rounded-pill px-3 py-1">
              <i class="fa-solid fa-triangle-exclamation text-light"></i>
            </span>
          </h1>
          <div class="text-center">
            <h3 class="font-weight-bold mb-2">{{ message.header }}</h3>
            <p class="mb-2">{{ message.message }}</p>
            <div class="d-flex align-items-center justify-content-center">
              <button type="button" @click="acceptCallback" class="btn btn-primary mr-2">OUI</button>
              <button type="button" @click="rejectCallback" class="btn btn-danger">NON</button>
            </div>
          </div>
        </div>
      </template>
    </ConfirmDialog>
  </div>
</template>

<script >
import packageJson from '../package.json';

export default {
  data() {
    return {
      loadingCompany: false,
      updateAvailable: false,
      updateDownloaded: false,
      updateInfo: null,
      majoff: false,
      timerId: null,             // Pour stocker l'intervalle
      // Nouvelle donnée pour gérer le mode du loader ("update" ou "ftp")
      currentMode: 'update',
      // Variable qui détermine si le téléchargement FTP est disponible (définie via une API) à remettre à false quand l'api sera configuré
      majDownloadAvailable: false,
      majDownloadInfo: {},
      dismissUpdateBanner: false,
      dismissMajBanner: false,
      localUpdates: []
    };
  },
  // computed: {
  //   // Est-ce que l'utilisateur est connecté ?
  //   isAuthenticated(): boolean {
  //     return this.$store.getters.authenticated;
  //   },
  //   // Nom de la route courante (pratique pour savoir où on est)
  //   currentRouteName(): string | undefined {
  //     return this.$route.name as string | undefined;
  //   },
  // },
  beforeCreate(){
    this.$store.dispatch('fetchApiConfigurations')
  },
  created() {
    // this.getCompanyInfo();
    this.checkHabilitations();
    this.checkMajAvailability();

    const storedUpdateDismiss = localStorage.getItem('dismissUpdateBanner');
    if (storedUpdateDismiss) this.dismissUpdateBanner = storedUpdateDismiss === 'true';

    const storedMajDismiss = localStorage.getItem('dismissMajBanner');
    if (storedMajDismiss) this.dismissMajBanner = storedMajDismiss === 'true';

    // this.callSuccess()
  },
  methods: {
    async checkHabilitations() {
      try {
        const response = await this.axios.get('/api/utilisateurs/' + this.$store.getters.user.id);
        const user = response.data.data;
        if (user.is_admin == false) {
          this.$store.commit('setUserHabilitations', user)
        }
      } catch (error) {
        console.error('Erreur lors du chargement des habilitations:', error);
      }
    },
    async fetchLocalUpdates() {
      try {
        const response = await this.axios.get('/api/epg/list-versions');
        if (response.data.status === 'success') {
          const zipFile = response.data.data; // Objet { name, version, date }
          console.log('Fichier ZIP trouvé:', zipFile);
          console.log('Version actuelle:', packageJson.version);
          // Version actuelle de l'app
          const currentVersion = packageJson.version; // ex: "3.3.1"

          // Compare
          if (this.versionCompare(zipFile.version, currentVersion) > 0 && zipFile.version == this.majDownloadInfo.version) {
            // Si zipFile.version == currentVersion ou zipFile.version > currentVersion
            this.updateDownloaded = true;
          } else {
            this.updateDownloaded = false;
          }
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des versions:', error);
      }
    },

    versionCompare(a, b) {
      const aParts = a.split('.').map(Number);
      const bParts = b.split('.').map(Number);

      for (let i = 0; i < Math.max(aParts.length, bParts.length); i++) {
        const numA = aParts[i] || 0;
        const numB = bParts[i] || 0;
        if (numA > numB) return 1;
        if (numA < numB) return -1;
      }
      return 0; // Égalité
    },
    async checkMajAvailability() {
      // Vérifier s'il y a une connexion internet
      if (!navigator.onLine) {
        console.warn("Pas de connexion internet. La vérification de la mise à jour est désactivée.");
        return;
      }
      try {
        // Appel API pour vérifier la disponibilité de la mise à jour FTP
        const response = await this.axios.get(this.$store.state.superviseurApi + '/api/epg/latest-maj');
        // On suppose que la réponse renvoie { version: "3.3.4", download_url: "..." }

        const apiVersion = response.data.data.version;
        const downloadUrl = response.data.data.lien_telechargement;

        // Si la version renvoyée par l'API est supérieure à la version installée
        if (this.isNewerVersion(apiVersion, packageJson.version)) {
          this.majDownloadAvailable = true;
          this.fetchLocalUpdates();
          // Vous pouvez stocker d'autres infos utiles
          this.majDownloadInfo = { version: apiVersion, download_url: downloadUrl };
        } else {
          this.majDownloadAvailable = false;
        }
      } catch (error) {
        console.error('Erreur lors de la vérification de la disponibilité FTP :', error);
        this.majDownloadAvailable = false;
      }
    },

    // Méthode utilitaire pour comparer les versions (format "X.Y.Z")
    isNewerVersion(newVersion, currentVersion) {
      const newParts = newVersion.split('.').map(Number);
      const currentParts = currentVersion.split('.').map(Number);
      for (let i = 0; i < Math.max(newParts.length, currentParts.length); i++) {
        const newVal = newParts[i] || 0;
        const curVal = currentParts[i] || 0;
        if (newVal > curVal) return true;
        if (newVal < curVal) return false;
      }
      return false;
    },









    /**
     * Retourne true si la page actuelle est une page "auth"
     * sur laquelle on ne veut pas faire de fetch/redirect pharmacie.
     */
    //  isOnAuthPage(): boolean {
    //   const authRoutes = ['login', 'activation', 'new.password'];
    //   return !!this.currentRouteName && authRoutes.includes(this.currentRouteName);
    // },

    /**
     * Vérifie si la configuration pharmacie est incomplète.
     * On supporte à la fois :
     *  - ancien schéma : nom_pharmacie, devise
     *  - nouveau schéma : name, currency
     */
    // isPharmacyIncomplete(pharmacy: any): boolean {
    //   if (!pharmacy) return true;

    //   const candidateNameKeys = ['name', 'nom_pharmacie'];
    //   const candidateCurrencyKeys = ['currency', 'devise'];

    //   const hasName = candidateNameKeys.some((key) => {
    //     const value = pharmacy[key];
    //     return value !== null && value !== undefined && String(value).trim() !== '';
    //   });

    //   const hasCurrency = candidateCurrencyKeys.some((key) => {
    //     const value = pharmacy[key];
    //     return value !== null && value !== undefined && String(value).trim() !== '';
    //   });

    //   // Tu peux renforcer ici (ex: exiger aussi une adresse)
    //   return !hasName || !hasCurrency;
    // },

    /**
     * Récupère les infos de la pharmacie.
     * 1. Tente le nouvel endpoint /api/v1/pharmacy
     * 2. Si échec ou vide -> tente l'ancien /api/pharmacie-info
     * 3. Stocke le résultat dans le store
     * 4. Si la config est vide/incomplète -> redirige vers la page de paramétrage
     */
    // async getCompanyInfo(): Promise<void> {
    //   // Inutile de faire ce fetch sur les pages de login/activation/mot de passe
    //   if (this.isOnAuthPage()) return;

    //   this.loadingCompany = true;

    //   try {
    //     let pharmacy: any = null;

    //     try {
    //         const responseLegacy = await this.axios.get('/api/pharmacie-info');
    //         pharmacy = responseLegacy.data?.data
    //         this.$store.commit('setPharmacieDatas', pharmacy);
    //       } catch (error) {
    //         // On ignore, pharmacy restera null
    //       }

    //     // 4️⃣ Si la config est vide/incomplète -> redirection vers la page de configuration
    //     if (this.isPharmacyIncomplete(pharmacy)) {
    //       const isAlreadyOnConfigPage = this.currentRouteName === 'parametrage';
    //       const isOnAuth = this.isOnAuthPage();

    //       if (!isAlreadyOnConfigPage && !isOnAuth) {
    //         this.$router.push({ name: 'parametrage' });
    //       }
    //     }
    //   } finally {
    //     this.loadingCompany = false;
    //   }
    // }
















  },
};
</script>

<!-- <style lang="scss">
.update-banner {
  position: fixed;
  bottom: 40px;
  width: 100%;
  background-color: rgba(42, 57, 99, 0.8);
  text-align: center;
  padding: 0.5rem 1rem;
  z-index: 1020;

  &.no-footer {
    bottom: 0;
    padding: 1rem;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  }
}

.update-bannerFTP {
  position: fixed;
  top: 60px;
  width: 100%;
  background-color: rgba(42, 57, 99, 0.8);
  text-align: center;
  padding: 0.5rem 1rem;
  z-index: 1020;

  &.no-header {
    top: 0;
    padding: 1rem;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }
}

/* ------------------------------ */
/* Nouveau style pour le bouton downloadUpdate */
/* ------------------------------ */

.download-btn {
  background: none;
  border: none;
  color: #007bff;
  /* couleur Bootstrap pour les liens */
  padding: 0;
  font-size: 1rem;
  text-decoration: none;
  cursor: pointer;
}

.close-btnBadge {
  /* ... autres propriétés ... */
  position: absolute;
  top: 8px;
  right: 12px;
  display: inline-block;
  background: none;
  border: none;
  color: white;
  font-size: 1rem;
  cursor: pointer;
  padding: 2px 5px;
  text-decoration: none;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

  /* Effet de soulignement animé */
  background-image: linear-gradient(white, white);
  background-size: 0% 2px;
  background-repeat: no-repeat;
  background-position: left 85%;
}

.close-btnBadge:hover {
  background-size: 100% 2px;
  opacity: 0.9;
}

.download-btn:hover {
  text-decoration: underline;
  color: #94a0ab;
}
</style> -->
